(function() {
    $(document).ready(function() {
        $('.mod24EmptyBox').closest('.c24-cnt-ele').remove();
    });
})();
